module.exports = __webpack_public_path__ + "img/eyeOpen.9244cb33.svg";